import { render, staticRenderFns } from "./IrisQuickActionButton.vue?vue&type=template&id=af946046&"
import script from "./IrisQuickActionButton.vue?vue&type=script&lang=ts&"
export * from "./IrisQuickActionButton.vue?vue&type=script&lang=ts&"
import style0 from "./IrisQuickActionButton.vue?vue&type=style&index=0&id=af946046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports